/* eslint-disable complexity */
import React from "react";
import style from "./styles";
import PropTypes from "prop-types";
const LessLink = (props) => {
  const { showLessText } = props;
  return (
    <>
      <style jsx>{style}</style>
      <p className={"show-more-link " + props.className} data-testid="component-lessLink">
        <button className={"linkButton " + props.className}>{showLessText}</button>
      </p>
    </>
  );
};
export { LessLink };

LessLink.defaultProps = {
  paddingTop: null,
  showLessText: "Show Less",
  className: "",
};

LessLink.propTypes = {
  paddingTop: PropTypes.string,
  showLessText: PropTypes.string,
  className: PropTypes.string,
};
